module.exports = ".title{\r\n  padding-left: 28px !important;\r\n}\r\n.nav-item {\r\n  color: rgb(12, 12, 12);\r\n}\r\n#part {\r\n  margin-bottom: 4px;\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n  font-weight: 600;\r\n}\r\n.mat-tab-label {\r\n  font-size: larger !important;\r\n  font-weight: 600 !important;\r\n}\r\n.mat-tab-label-active {\r\n  border-bottom: 1px solid #007bff !important;\r\n}\r\n#itemsss {\r\n  height: 200px;\r\n}\r\n.imag {\r\n  height: 94px;\r\n  width: auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/service/service.component.css
// module id = ./src/app/home/service/service.component.css
// module chunks = main